import Script from "next/script";
const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;

/**
 * Loads GTM for every visitor. Consent is enforced through Google Consent Mode
 * v2: `GOOGLE_CONSENT_DEFAULT` (injected `beforeInteractive` from
 * `_document.tsx`) denies storage before this runs, and the application
 * consent controller pushes the effective choices. Google tags fire in
 * cookieless modeling mode until the visitor accepts, rather than the
 * container not loading at all.
 *
 * Because the container is no longer gated behind consent, every NON-Google tag
 * inside the GTM container (custom HTML, LinkedIn/Meta pixels, etc.) must carry
 * its own consent requirement in GTM; only Google tags respect Consent Mode
 * automatically. As of 2026-10 the container (GTM-KTL7CRT) still sets none, so
 * Hotjar/HubSpot/Clarity/LinkedIn fire before consent — that fix lives in the
 * GTM admin, not here.
 *
 * `afterInteractive`, not `lazyOnload`: Google's consent-signal and modeling
 * checks expect the tag to run on page load rather than after everything else,
 * and GA Admin reported analytics consent signals as inactive while this was
 * `lazyOnload`. The denied default still lands first — it is injected
 * `beforeInteractive` from `_document.tsx`.
 */
export function GoogleTagManagerScript() {
  if (!GTM_ID) {
    return null;
  }
  return <Script id="google-tag-manager" strategy="afterInteractive" dangerouslySetInnerHTML={{
    __html: `
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', '${GTM_ID}');
    `
  }} />;
}